<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="基础信息">
        <table cellspacing="0" cellpadding="0" class="defaultTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">系统编号：</td>
            <td>{{returnOrderVO.returnOrderNo}}</td>
            <td class="tableLabel">申请人人：</td>
            <td>{{returnOrderVO.creatorName}}</td>
            <td class="tableLabel">申请日期：</td>
            <td>{{returnOrderVO.createTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">申请部门：</td>
            <td>{{returnOrderVO.departmentName}}</td>
            <td class="tableLabel">提交时间：</td>
            <td>{{returnOrderVO.submitTime}}</td>
            <td class="tableLabel">流程状态：</td>
            <td v-if="returnOrderVO.status === 0"> <el-tag type="info">草稿</el-tag></td>
            <td v-else> <el-tag type="info">{{returnOrderVO.nodeDesc}}</el-tag></td>
          </tr>
        </table>
        <div>
          <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">物料信息</div>
          <el-table
              :data="returnOrderVO.details"
              :span-method="mergeCells">
            <el-table-column prop="factoryNo" width="100" align="center" label="出厂编号"/>
            <el-table-column prop="customerName" width="110" align="center" label="客户名称"/>
            <el-table-column prop="materialNo" width="90" align="center" label="物料编号"/>
            <el-table-column prop="materialName" width="120" align="center" label="物料名称"/>
            <el-table-column prop="quantity" align="center" label="数量"/>
            <el-table-column prop="reason" width="120" align="center" label="退货理由"/>
            <el-table-column prop="remark" width="120" align="center" label="处理意见"/>
            <el-table-column prop="amount" width="100" align="center" label="预估损失金额(元)"/>
            <el-table-column prop="returnDate" align="center" label="退库大概日期"/>
            <el-table-column prop="logistics" width="100" align="center" label="物流信息"/>
            <el-table-column prop="outStockNo" width="100" align="center" label="处理退货单号"/>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
  </div>
</template>

<script>
  import HandleDetail from "../../workFlow/HandleDetail.vue";
  export default {
    name:"",
    components:{HandleDetail},
    data() {
      return {
        billId:"",
        billType:"35",
        saveLoading: false,
        returnOrderVO: {
          pkid: "",
          billNo: "",
          creatTime: "",
        },
      };
    },
    created() {
      this.billId = this.$route.query.billId;
      this.getData();
    },
    destroyed() {
      this.billId = "";
      this.returnOrderVO={};
    },
    methods:{
      getData() {
        this.$http.get("basic",`returnOrders/${this.billId}`).then((res)=>{
          this.returnOrderVO = res;
        }).catch(()=>{
        });
      },
      // 合并单元格方法
      mergeCells({row, column, rowIndex, columnIndex}) {
        // 只处理出厂编号和客户名称列
        if (column.property === "factoryNo" || column.property === "customerName") {
          // 按出厂编号分组
          const sameFactoryNoItems = [];
          let currentFactoryNo = row.factoryNo;
          
          // 向前查找相同出厂编号的行
          for (let i = rowIndex; i >= 0; i--) {
            if (this.returnOrderVO.details[i].factoryNo === currentFactoryNo) {
              sameFactoryNoItems.unshift(this.returnOrderVO.details[i]);
            } else {
              break;
            }
          }
          
          // 向后查找相同出厂编号的行
          for (let i = rowIndex + 1; i < this.returnOrderVO.details.length; i++) {
            if (this.returnOrderVO.details[i].factoryNo === currentFactoryNo) {
              sameFactoryNoItems.push(this.returnOrderVO.details[i]);
            } else {
              break;
            }
          }
          
          // 只有第一个单元格需要显示，其余的隐藏
          if (sameFactoryNoItems.indexOf(row) === 0) {
            return {
              rowspan: sameFactoryNoItems.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      },
    },
  };
</script>

<style lang="scss">
table.defaultTable {
  font-family: verdana,arial,sans-serif;
  font-size:11px;
  color:#333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
table.defaultTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}
table.defaultTable td {
  padding: 8px;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}
.tableLabel {
  width: 10%;
  text-align: right;
  background-color: #D1E6F5;
}
</style>
